<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div style="width: calc(100vw - 268px); margin-bottom: 32px" class="" [hidden]="loadingCounter > 0">
  <div class="grid nested-grid">
    <div class="col-9" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-4">
                <med-icon-aimbulance
                  size="48"
                  mode="square"
                ></med-icon-aimbulance>
              </div>

              <div class="col-8">
                      <span class="white-space-nowrap postavka">
                          Розподіл &nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                <br>
                <div class="flex flex-between gap-3">
                  <div class="h10-text" style="display: inline-flex; white-space: nowrap">Статус:&nbsp; <img [src]="getPathToStatusToYellowImg()" width="4" height="16" style="vertical-align: middle;"/>&nbsp;{{getStatus()}}</div>
                  <div class="h10-text" style="display: inline-flex" *ngIf="distributionApproved && distribution.signStatus === 'SIGNED'">Рішення:&nbsp; <img [src]="getPathToStatusImg('active')" width="4" height="16" style="vertical-align: middle;"/>&nbsp;Розподілено</div>
                  <div class="h10-text" style="display: inline-flex" *ngIf="distribution.signStatus === 'Відмова'">Рішення:&nbsp; <img [src]="getPathToStatusToRedImg()" width="4" height="16" style="vertical-align: middle;"/>&nbsp;Відмова</div>
                  <div class="h10-text" style="display: inline-flex; white-space: nowrap" *ngIf="distribution.signStatus === 'SUPPLY_STATUS_PARTIALLY_APPROVED'">Рішення:&nbsp; <img [src]="getPathToStatusToYellowImg()" width="4" height="16" style="vertical-align: middle"/>&nbsp;Часткове підтвердження</div>
                  <div *ngIf="distribution.signStatus === 'SUPPLY_STATUS_PARTIALLY_APPROVED'">
                    <med-icon-info size="16" [pTooltip]="tooltipPartiallyApproved"></med-icon-info>
                    <ng-template #tooltipPartiallyApproved>
                      <div class="doz-tooltip-content">
                        <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">
                          <div style="color: white" class="h10-text col-12">
                            Відмовлено по МНН
                          </div>
                        </div>
                        <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">
                          <div class="mobile-h10-text text-white-alpha-80 col-6">
                            Ранітидин:
                          </div>
                          <div style="color: white" class="h10-text col-6">
                            12
                          </div>
                        </div>
                        <div class="flex flex-between justify-content-center grid-nogutter" style="width: 100%; justify-content: space-between!important;">
                          <div class="mobile-h10-text text-white-alpha-80 col-6">
                            Метранідазол:
                          </div>
                          <div style="color: white" class="h10-text col-6">
                            12
                          </div>
                        </div>

                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="padding: 16px; margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 10vh">


            <div class="col-3 flex" style="flex-direction: column">
                      <span class="mobile-h10-text">
                          Дата розподілу
                      </span>

              <span class="h10-text" style="margin-top: 8px">
                          {{distribution.orderDate | date: 'dd.MM.yyyy'}}
                      </span>
            </div>
              <div class="col-3 flex" style="flex-direction: column">
              <span class="mobile-h10-text">
                          Розподіл виконано
                      </span>
              <span class="h10-text" style="margin-top: 8px">
                          {{distribution.distributionType}}
                      </span>
              </div>
              <div class="col-3 flex" style="flex-direction: column">
              <span class="mobile-h10-text">
                          Напрям
                      </span>
              <span class="h10-text" style="margin-top: 8px">
                          {{distribution.direction?.shortName}}
                      </span>
              </div>
            <div class="col-3 flex" style="flex-direction: column">
              <span class="mobile-h10-text">
                          Регіон
                      </span>
              <span class="h10-text" style="margin-top: 8px">
                           {{ distribution.region?.name }}
                      </span>
            </div>


          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-3" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-6">
                <med-icon-key-large
                  size="48"
                  mode="circle"
                ></med-icon-key-large>
              </div>

              <div class="col-6 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="padding: 16px; margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 10vh">
            <div class="col-6">
              <div class="mobile-h10-text">
                          ПІБ
                      </div>

                <div class="h10-text" style="margin-top: 8px">
<!--                          <med-bubble>-->
                            {{ signerFullName() }}
<!--                          </med-bubble>-->
                      </div>
            </div>
            <div class="col-6">
              <div class="mobile-h10-text">
                Час підпису
              </div>

              <div class="h10-text" style="margin-top: 8px">
<!--                <med-bubble>-->
                  {{ signerDate() | date: 'dd.MM.yyyy' }}
<!--                </med-bubble>-->
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>


<div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="!showSubDistributionCreationView">
  <p-table
    #dt
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="distribution.goodSpecifications"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeader"
    [reorderableColumns]="true"
    (onColReorder)="saveColumnOrder('distributionDozColumnOrder', tabHeader)">
    <ng-template pTemplate="header">
      <tr>
        <ng-container *ngFor="let column of tabHeader">
        <th class="table-header-text table-header-bg-grey" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center no-wrap"
          [ngStyle]="{
            'max-width': ['2', '3', '4'].includes(column.key) ? '13em' : 'unset',
            'min-width': ['2', '3', '4'].includes(column.key) ? '13em' : '3em'
          }"
          >
            {{ column.label }}
          </div>
        </th>

      </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row  let-columns="columns">
      <tr class="table-content-text">
        <ng-container *ngFor="let col of columns">
        <td class="h10-text black-80" *ngIf="col.key === '1'">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipmnnName">
                          {{row.good.mnnName}}
                        </span>
            <ng-template #tooltipmnnName>
              <div class="flex items-center h10-text">
                {{row.good.tradeName}}
              </div>
            </ng-template>
          </div>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '2'">
          <span>{{row.distributedQuantity}}</span>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '3'">
          <span>{{row.requisitions100}}</span>
        </td>
        <td class="h10-text black-60" *ngIf="col.key === '4'">
          <span>{{row.requisitionsFinanced}}</span>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === '5'">
          <span>{{row.remnants}}</span>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '6'">
          <ul style="list-style: none;padding-left: 0;padding-top: 0; margin: 0">
            <li *ngFor="let series of row.seriesCatalogues" class="small-text">
              {{ series }}
            </li>
          </ul>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '7'">
          <span>{{ row.good.releaseForm }}</span>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '8'">
          <span>{{row.good.unit}}</span>
        </td>
        <td class="h10-text black-80" *ngIf="col.key === '9'">
          <span>{{row.multiplicity}}</span>
        </td>
        <td class="h10-text black-90" style="padding: 0" *ngIf="col.key === '10'">

          <div *ngFor="let beneficiary of row.beneficiaries" class="small-text table-cell" style="padding-left: 16px; border-left: 1px solid #C7C7C7;" [ngClass]="{'bg-orange-50' : beneficiary.accountingDocumentType === 'Лист про відмову від отримання', 'bg-cyan-50' : beneficiary.accountingDocumentType === 'Акт пересорту', 'bg-bluegray-50' : beneficiary.accountingDocumentType === 'Акт нестачі'}">
            <med-input  [size]="'small'"
                        *ngIf="!distributionApproved"
                        type="number"
                        [(ngModel)]="beneficiary.quantityDoz"
                        [state]="getValidationState(beneficiary)"
                        (focusout)="validateBase(row)"></med-input>
            <span *ngIf="distributionApproved">
              <div class="flex flex-between justify-content-start">
                <div>
                  {{beneficiary.quantityDoz}}
                  &nbsp;
                  {{getDiff(beneficiary.quantityDoz, beneficiary.quantityExpert)}}
                </div>

                <div *ngIf="beneficiary.accountingDocumentType === 'Лист про відмову від отримання'">
                  <med-icon-block size="16" class="text-red-500 cursor-pointer" [pTooltip]="tooltipDeclineAccounting"></med-icon-block>
                  <ng-template #tooltipDeclineAccounting>
                    <div class="flex items-center h10-text text-red-50">
                      Отримано лист про відмову від отримання
                    </div>
                  </ng-template>
                </div>

                <div *ngIf="beneficiary.accountingDocumentType === 'Акт пересорту'">
                  <med-icon-block size="16" class="text-purple-500 cursor-pointer" [pTooltip]="tooltipDeclineAccounting"></med-icon-block>
                  <ng-template #tooltipDeclineAccounting>
                    <div class="flex items-center h10-text text-purple-50">
                      Отримано лист про Акт пересорту
                    </div>
                  </ng-template>
                </div>

                <div *ngIf="beneficiary.accountingDocumentType === 'Акт нестачі'">
                  <med-icon-block size="16" class="text-orange-500 cursor-pointer" [pTooltip]="tooltipDeclineAccounting"></med-icon-block>
                  <ng-template #tooltipDeclineAccounting>
                    <div class="flex items-center h10-text text-orange-50">
                      Комісійний акт про пошкодження або Акт нестачі
                    </div>
                  </ng-template>
                </div>

                <div *ngIf="beneficiary.transactionDocumentId" [pTooltip]="tooltipOnApprovement">
                  <med-icon-question size="16" class="text-yellow-400"></med-icon-question>
                  <ng-template #tooltipOnApprovement>
                    <div class="flex items-center h10-text text-yellow-50">
                      Очікує підтвердження отримувачем
                    </div>
                   </ng-template>
                </div>
                <div *ngIf="beneficiary.errorMessage" class="cursor-pointer" [pTooltip]="tooltiErrorText">
                  <med-icon-warning size="16" class="text-red-100"></med-icon-warning>
                  <ng-template #tooltiErrorText>
                    <div class="flex items-center h10-text text-red-50">
                      {{beneficiary.errorMessage}}
                    </div>
                   </ng-template>
                </div>
              </div>
            </span>
          </div>
        </td>
        <td class="h10-text black-80" style="padding: 0" *ngIf="col.key === '11'">
            <div *ngFor="let beneficiary of row.beneficiaries" class="small-text table-cell flex flex-between justify-content-start" style="padding-left: 16px; padding-right: 16px;" [ngClass]="{'bg-orange-50' : beneficiary.accountingDocumentType === 'Лист про відмову від отримання', 'bg-cyan-50' : beneficiary.accountingDocumentType === 'Акт пересорту', 'bg-bluegray-50' : beneficiary.accountingDocumentType === 'Акт нестачі'}">
              <div>{{ beneficiary.organization.shortName }}</div>
              <div *ngIf="beneficiary.transactionDocumentId" class="flex flex-between justify-content-end">
                  <med-icon-check size="16" class="text-green-500 cursor-pointer" [pTooltip]="tooltipApprove" (click)="approveReceipt(beneficiary.transactionDocumentId)"></med-icon-check>
                  <ng-template #tooltipApprove>
                    <div class="flex items-center h10-text text-green-50">
                      Підтвердити надходження
                    </div>
                  </ng-template>
                  <med-icon-block size="16" class="text-red-500 cursor-pointer" [pTooltip]="tooltipDecline" (click)="declineReceipt(beneficiary.transactionDocumentId, 'Лист про відмову від отримання')"></med-icon-block>
                  <ng-template #tooltipDecline>
                    <div class="flex items-center h10-text text-red-50">
                      Відмовитись від надходження
                    </div>
                  </ng-template>

                <med-icon-refresh size="16" class="text-blue-500 cursor-pointer" [pTooltip]="tooltipDecline1" (click)="declineReceipt(beneficiary.transactionDocumentId, 'Акт пересорту')"></med-icon-refresh>
                <ng-template #tooltipDecline1>
                  <div class="flex items-center h10-text text-blue-50">
                    Видати акт пересорту
                  </div>
                </ng-template>


                <med-icon-bug size="16" class="text-purple-500 cursor-pointer" [pTooltip]="tooltipDecline2" (click)="declineReceipt(beneficiary.transactionDocumentId, 'Акт нестачі')"></med-icon-bug>
                <ng-template #tooltipDecline2>
                  <div class="flex items-center h10-text text-purple-50">
                    Видати Комісійний акт про пошкодження або Акт нестачі
                  </div>
                </ng-template>

                  <p-dialog header="Use this id for swagger" [modal]="true" [(visible)]="visible" [style]="{ width: '50vw' }">
                    <pre>
                      {{dataToSignAccounting | json}}
                    </pre>
                    <med-btn (click)="apprReceipt()">Підтвердити надходження</med-btn>
                  </p-dialog>
              </div>
            </div>
        </td>
      </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>

<div *ngIf="showSubDistributionCreationView">
  <div class="flex mb-2">
    <div class="h7-heading">Наявність на базі: </div>
    &nbsp;
    <div style="width: 400px">
      <med-select
        [options]="selectOptions"
        placeholder="Оберіть базу"
        [(ngModel)]="selectedBaseId"
        (ngModelChange)="onInput($event)"></med-select>
    </div>
  </div>

  <div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="goodSpecsForSelection.length > 0">
    <p-table
      styleClass="p-datatable-sm"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="goodSpecsForSelection"
      [customSort]="true"
      [lazy]="true"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [columns]="subTabHeader"
      [reorderableColumns]="true"
      (onColReorder)="saveColumnOrder('subColumnOrder', subTabHeader)">
      <ng-template pTemplate="header">
        <tr>
          <th>
          </th>
          <ng-container *ngFor="let column of subTabHeader">
            <th class="table-header-text table-header-bg-grey" pReorderableColumn pResizableColumn>
              <div style="display: inline-block" class="flex align-items-center">
                {{ column.label }}
              </div>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr class="table-content-text">
          <td class="h10-text black-80">
            <med-checkbox size="small"
                          (change)="onChangeHandlerSpecification(row)"
                          [value]="basket.containsSpecification(row)" [disabled]="getAvailableQuantityForBase(row) === '0'">

            </med-checkbox>
          </td>
          <ng-container *ngFor="let col of columns">
          <td class="h10-text black-80" *ngIf="col.key === '1'">
            <span>{{row.good.mnnId}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '2'">
            <span>{{row.good.mnnName}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '3'">
            <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipTradeName">
                          {{row.good.tradeName}}
                        </span>
              <ng-template #tooltipTradeName>
                <div class="flex items-center h10-text">
                  {{row.good.tradeName}}
                </div>
              </ng-template>
            </div>
          </td>
          <td class="h10-text black-60" *ngIf="col.key === '4'">
            <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDosage">
                          {{row.good.dosage}}
                        </span>
              <ng-template #tooltipDosage>
                <div class="flex items-center h10-text">
                  {{row.good.dosage}}
                </div>
              </ng-template>
            </div>
          </td>

          <td class="h10-text black-80" *ngIf="col.key === '5'">
            <span>{{row.good.releaseForm}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '6'">
            <span>{{row.good.releaseForm}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '7'">
            <span>{{row.multiplicity}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '8'">
            <span>{{row.requisitions100}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '9'">
            <span>{{row.requisitionsFinanced}}</span>
          </td>
          <td class="h10-text black-90" *ngIf="col.key === '10'">
            {{row.seriesCatalogue}}
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '11'">
            <span>{{row.remnants}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === '12'">
            <span>{{getDistributedQuantityForBase(row)}}
              &nbsp;
              (доступно {{getAvailableQuantityForBase(row)}})
            </span>
          </td>
        </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<div
  [style.width]="'calc(100vw - 0px)'"
  [style.height]="'60px'"
  class="med-layout__footer"
>
  <div class="med-layout__footer-content">
    <div class="flex flex-center flex-between">
      <div class="flex flex-center">

        <med-btn class="mr-1" (click)="goToDistributions()">
          <med-icon-reply size="18"></med-icon-reply>
          &nbsp;
          <span>До реєстру розподілу</span>
        </med-btn>

        <med-btn class="mr-1" (click)="openAttachmentsModal()">
          <span>Вкладення</span>
          &nbsp;
          {{ attachments.content.length }}
        </med-btn>

        <med-btn class="mr-1" (click)="reviewModal = true">
          <span>Переглад</span>
          &nbsp;
          <med-icon-visibility size="18"></med-icon-visibility>
        </med-btn>

        <med-btn class="mr-1" (click)="downloadExcel()">
          <med-icon-download size="18"></med-icon-download>
        </med-btn>

      </div>
      <div class="flex flex-center" *ngIf="!READONLY">
        <med-btn class="mr-1" (click)="beneficiaryUpdate()" *ngIf="distribution.signStatus !== 'Відмова' && !signed">
          <span>Оновити отримувачів</span>
        </med-btn>

        <med-btn skin="red" (click)="showRefuseModal()" *ngIf="distribution.signStatus !== 'Відмова' && !signed">
          <span>Відмовитися</span>
          &nbsp;
          <med-icon-block size="18"></med-icon-block>
        </med-btn>

        <med-btn class="mд-1" (click)="save(false)" *ngIf="distribution.signStatus !== 'Відмова' && !signed">
          <med-icon-archive size="16"></med-icon-archive>
          &nbsp;
          <span>Зберегти</span>
        </med-btn>

        <med-btn skin="yellow" class="ml-1" (click)="save(true)" *ngIf="distribution.signStatus !== 'Відмова' && !signed" [disabled]="distributionHasValidationErrors()">
          <span>Завершити розподіл</span>
          &nbsp;
          <med-icon-check size="18"></med-icon-check>
        </med-btn>
      </div>
      <div class="flex flex-center" *ngIf="(distributionApproved && !showSubDistributionCreationView) || signed && !showSubDistributionCreationView">
        <med-btn skin="yellow" (click)="subDistributionAgreementModal = true">
          <med-icon-plus size="18"></med-icon-plus>
          &nbsp;
          <span>Створити дочірній розподіл</span>
        </med-btn>
      </div>
      <div class="flex flex-center" *ngIf="showSubDistributionCreationView">
        <med-btn (click)="basket.clear()" *ngIf="basket.basketHasItems()">
          <med-icon-block size="18"></med-icon-block>
          &nbsp;
          <span>Скинути все</span>
        </med-btn>
        <med-btn skin="yellow" (click)="goToBasketDoz()" [disabled]="!this.basket.basketHasItems()">
          <med-icon-plus size="18"></med-icon-plus>
          &nbsp;
          <span>Застосувати вибір</span>
        </med-btn>
      </div>
    </div>
  </div>
</div>


<med-modal
  [(visible)]="attachmentsModal"
>
  <div>
    <div class="flex flex-center mb-4">
      <med-icon-docs
        size="36"
        mode="square"
      ></med-icon-docs>

      <h6 class="text extra-large ml-2 mb-0 mt-0">
        Вкладення
      </h6>
    </div>

    <app-loader *ngIf="attachments.isLoading"></app-loader>
    <div class="table-wrapper" style="height: unset" *ngIf="!attachments.isLoading">
      <p-table
        #dt
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="attachments.content"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [columns]="attachmentsTabHeader"
        [reorderableColumns]="true"
        (onColReorder)="saveColumnOrder('attachemntsDozColumnOrder', attachmentsTabHeader)">

        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let column of attachmentsTabHeader">
              <th class="mobile-h10-text table-header-bg-grey" pReorderableColumn pResizableColumn>
                  <div style="display: inline-block" class="flex align-items-center">
                      {{ column.label }}&nbsp;
                  </div>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row  let-columns="columns">
          <tr class="table-content-text">
            <ng-container *ngFor="let col of columns">
            <td class="black-80 h9-text" *ngIf="col.key === '1'">
              {{ row.type }}
            </td>
            <td class="black-60 h10-text" *ngIf="col.key === '2'">
              {{ row.fileName }}
            </td>
            <td class="black-80 h9-text" *ngIf="col.key === '3'">
              {{ row.fileNumber }}
            </td>
            <td class="black-80 h9-text" *ngIf="col.key === '4'">
              {{ row.selectedDate | date: 'dd.MM.yyyy' }}
            </td>

            <td class="black-80 h9-text" *ngIf="col.key === '5'">
              {{row.owner}}
            </td>
            <td *ngIf="col.key === '6'">
              <med-btn size="small" skin="white">
                <med-icon-download size="16" (click)="downloadFile(row)"></med-icon-download>
              </med-btn>
            </td>
          </ng-container>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="reviewModal">
  <app-view-distribution-modal [distributionId]="distributionId" [isDoz]="true"></app-view-distribution-modal>
</med-modal>

<med-modal [(visible)]="refuseModal" [closeableOutside]="false">
<!--  <div style="padding: 80px 148px">-->
  <div style="padding: 5px 10px">

    <app-loader *ngIf="refuseRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>


    <div style="width: 480px"  *ngIf="refuseRequestCounter === 0 && !refused">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відмовитися від розподілу
      </div>

      <div style="margin-top: 24px">
        <span class="h10-text black-60">
          Коментар
        </span>
        <span class="h10-text black-30">
          0/1000
        </span>
      </div>

      <div>
        <med-textarea height="88px" [(ngModel)]="dataToSign.comment">

        </med-textarea>
      </div>

      <p-scrollPanel [style]="{ 'height': '30vh' }">
      <div style="margin-top: 24px" *ngFor="let attachment of fileAttachments; let i = index">
          <med-card>
          <div class="flex flex-between flex-center">
            <med-radio-group position="horizontal" [options]="options" [value]="value" [(ngModel)]="attachment.type"></med-radio-group>
            <med-icon-close style="cursor: pointer" *ngIf="fileAttachments.length > 1" (click)="deleteAttachment(i)"></med-icon-close>
          </div>
          <div style="margin-top: 24px" class="flex flex-between flex-center">
            <div style="width: 50%">
              <med-input label="Номер документу" [(ngModel)]="attachment.number" [disabled]="!attachment.type"></med-input>
            </div>
            <div style="width: 50%; margin-left: 10px">
              <med-datepicker label="Дата" [(ngModel)]="attachment.selectedDate" [disabled]="!attachment.number"></med-datepicker>
            </div>
          </div>
          <div style="margin-top: 24px">
            <div style="width: 100%">
              <med-upload-file
                [disabled]="!attachment.number"
                [hideClearBtn]="true"
                accept=".pdf, .xls, .xlsx, .doc, .docx, .rtf, .txt, .ppt, .pptx"
                [binary]="true"
                placeholder="Завантажити файл"
                (onInput)="onFileInput($event)"
              ></med-upload-file>
            </div>
          </div>
        </med-card>
      </div>
    </p-scrollPanel>

      <div style="margin-top: 16px" class="flex flex-center justify-content-center">
        <med-btn (click)="addFileAttachment()">
          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>
          Додати ще вкладення
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuse()">
          Підписати
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="refuseRequestCounter === 0 && refused">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відмовитися від розподілу
      </div>

      <div style="padding-top: 24px">
        <med-card *ngIf="decryptedObject && decryptedObject.signerInfo">
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
                П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
                Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjFullName}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signedAt | date: 'dd.MM.yyyy hh:mm'}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.issuerCN}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.serial}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjEDRPOUCode}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjDRFOCode}}
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuseDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal [(visible)]="signModal" [closeableOutside]="false">
  <!--  <div style="padding: 80px 148px">-->
  <div style="padding: 5px 10px">

    <app-loader *ngIf="signRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && !signed">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл (Часткове підтвердження)
      </div>

<!--      <div style="margin-top: 24px">-->
        <p-scrollPanel [style]="{ 'height': '50vh' }">
          <div style="margin-top: 24px" *ngFor="let attachment of fileAttachments; let i = index">
        <med-card>
          <div class="flex flex-between flex-center">
            <med-radio-group position="horizontal" [options]="options" [value]="value" [(ngModel)]="attachment.type"></med-radio-group>
            <med-icon-close style="cursor: pointer" *ngIf="fileAttachments.length > 1" (click)="deleteAttachment(i)"></med-icon-close>
          </div>
          <div style="margin-top: 24px" class="flex flex-between flex-center">
            <div style="width: 50%">
              <med-input label="Номер документу" [placeholder]="attachment.type ? 'Введіть номер' : ''" [(ngModel)]="attachment.number" [disabled]="!attachment.type"></med-input>
            </div>
            <div style="width: 50%; margin-left: 10px">
              <med-datepicker label="Дата" [(ngModel)]="attachment.selectedDate" [disabled]="!attachment.number"></med-datepicker>
            </div>
          </div>
          <div style="margin-top: 24px">
            <div style="width: 100%">
              <med-upload-file
                [disabled]="!attachment.number || !attachment.type || !attachment.selectedDate"
                [hideClearBtn]="true"
                accept=".pdf, .xls, .xlsx, .doc, .docx, .rtf, .txt, .ppt, .pptx"
                [binary]="true"
                placeholder="Завантажити файл"
                (onInput)="onFileInput($event)"
              ></med-upload-file>
            </div>
          </div>
        </med-card>
      </div>
        </p-scrollPanel>

      <div style="margin-top: 16px" class="flex flex-center justify-content-center">
        <med-btn (click)="addFileAttachment()">
          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>
          Додати ще вкладення
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="sign()">
          Підписати
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && signed">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл
      </div>

      <div style="margin-top: 24px">
        <med-card *ngIf="decryptedObject && decryptedObject.signerInfo">
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
              Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjFullName}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signedAt | date: 'dd.MM.yyyy hh:mm'}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.issuerCN}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.serial}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjEDRPOUCode}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjDRFOCode}}
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="signDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="subDistributionAgreementModal"
  class="no-padding"
>
  <div style="width: 383px; height: 316px; padding: 32px">
    <div class="flex justify-content-center">
      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading" style="margin-top: 12px">
      Ви впевнені, що бажаєте створити дочірній розподіл?
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="createSubDistribution()" class="width-100">Підтвердити</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="subDistributionAgreementModal = false" class="width-100">Скасувати</med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="medSignModal"
  class="no-padding"
>
  <div style="width: 1000px; height: 600px; padding: 32px">
    <med-sign *ngIf="medSignModal"
      [data]="JSON.stringify(dataToSign)"
      (sign)="onSign($event)"
    ></med-sign>
  </div>
</med-modal>


<med-modal
  [(visible)]="accountingSignModal"
  class="no-padding"
>
  <div style="width: 1000px; height: 600px; padding: 32px">
    <med-sign *ngIf="accountingSignModal"
              [data]="JSON.stringify(dataToSignAccounting)"
              (sign)="onSignAccounting($event)"
    ></med-sign>
  </div>
</med-modal>
